/**
 * Auth action types.
 */
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const SET_LOADER = 'SET_LOADER'
export const SET_CONTACT_FILTER = 'SET_CONTACT_FILTER';